import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "notification-new-feature",
  "use": "notification-new-feature-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 15\" id=\"notification-new-feature\">\n  <path fill-rule=\"evenodd\" d=\"M579,192.007H567.751v3.751H564V207.01h11.252v-3.751H579V192.007Zm-5,13.753h-8.752v-8.752h2.5v6.251H574v2.5Zm3.75-3.751H569v-8.752h8.751v8.752Zm-5-1.25H574v-2.5h2.5v-1.25H574v-2.5h-1.251v2.5h-2.5v1.25h2.5v2.5Z\" transform=\"translate(-564 -192)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/notification-new-feature.svg
// module id = null
// module chunks = 